import React, { useState, useEffect } from "react";
import { bool, string } from "prop-types";
import { Form, withFormik } from "formik";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { ResponsiveHeader } from "pages/_components/header";
import Head from "pages/_components/Head";
import Button from "pages/_components/Button";
import { goBack, push } from "connected-react-router";
import MainContainer from "pages/_components/MainContainer";
import I18n from "pages/_components/I18n";
import * as Yup from "yup";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import { Col, Row } from "react-bootstrap";
import * as i18n from "util/i18n";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import { usePrevRoute } from "hooks/usePrevRoute";
import ErrorPopup from "../../onboarding/_components/ErrorPopup";
import Stepper from "../../onboarding/_components/Stepper";

const PAGE_ID = "StepCaptureSelfie";

const StepCaptureSelfieMigration = ({ fetching, isMobile, errorValidateIdentity }) => {
    const [error, setError] = useState("");
    const { prevPath } = usePrevRoute();

    const dispatch = useDispatch();

    useEffect(() => {
        if (prevPath === "/migration/StepCaptureSelfieSuccess") {
            dispatch(push("/migration/StepCaptureSelfieSuccess"));
        } else {
            dispatch(onboardingActions.resetIdentityValidationProgress());
        }
    }, []);

    useEffect(() => {
        if (!fetching && errorValidateIdentity !== null) {
            setError(errorValidateIdentity);
            dispatch(modalActions.modalShow());
        }
    }, [fetching, errorValidateIdentity]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
    };

    return (
        <>
            {isMobile && <ResponsiveHeader ticket id="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}
            {!isMobile && <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />}
            <MainContainer>
                <Stepper isMobile={isMobile} page={PAGE_ID} />
                <Form className="above-the-fold">
                    <h1 className="text-center" style={{ textAlign: "left" }}>
                        <I18n id="onboarding.captureSelfie.title" defaultValue="Reconocimiento facial" />
                    </h1>
                    <div className="card">
                        <I18n
                            id="onboarding.captureSelfie.information"
                            defaultValue="Antes de realizar el reconocimiento facial, tené en cuenta lo siguiente:"
                        />
                        <div className="paso2 reconocimiento-facial">
                            <Row>
                                <Col xs={3}>
                                    <Image src="figma/illustrations/selfie_fondo_claro.svg" className="svg-image" />
                                </Col>
                                <Col xs={9} style={{ paddingTop: "35px" }}>
                                    <div>
                                        <CustomText text={i18n.get("", "Buscá un fondo claro.")} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={3}>
                                    <Image src="figma/illustrations/selfie_iluminado.svg" className="svg-image" />
                                </Col>
                                <Col xs={9} style={{ paddingTop: "35px" }}>
                                    <div>
                                        <CustomText text={i18n.get("", "Buscá un lugar iluminado.")} />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={3}>
                                    <Image src="figma/illustrations/selfie_anteojos.svg" className="svg-image" />
                                </Col>
                                <Col xs={9} style={{ paddingTop: "35px" }}>
                                    <div>
                                        <CustomText
                                            text={i18n.get("", "Sin anteojos, gorro u otro accesorio en la cara.")}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={3}>
                                    <Image src="figma/illustrations/selfie_ubicar_celular.svg" className="svg-image" />
                                </Col>
                                <Col xs={9} style={{ paddingTop: "35px" }}>
                                    <div>
                                        <CustomText text={i18n.get("", "Ubicá el celular a la altura de tu rostro.")} />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>

                    <div className="form-actions">
                        <Button
                            bsStyle="primary"
                            label="global.begin"
                            defaultLabelText="Comenzar"
                            type="submit"
                            block
                            loading={fetching}
                        />
                    </div>
                </Form>
            </MainContainer>
            <ErrorPopup error={error} handleClick={handleClickButtonClose} />
        </>
    );
};

StepCaptureSelfieMigration.propTypes = {
    fetching: bool.isRequired,
    isMobile: bool.isRequired,
    errorValidateIdentity: string,
};

StepCaptureSelfieMigration.defaultProps = {
    errorValidateIdentity: null,
};

const mapStateToProps = (state) => ({
    fetching: onboardingSelectors.getFetching(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    errorValidateIdentity: onboardingSelectors.getErrorValidateIdentity(state),
    documentData: onboardingSelectors.getDocumentData(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: (props) => ({
            document: props.documentData?.documentNumber,
            gender: props.documentData?.gender,
            exchangeToken: props.exchangeToken,
            onboardingWithInvitation: props.onboardingWithInvitation,
        }),
        validationSchema: () => Yup.object().shape({}),
        handleSubmit: ({ document, gender, exchangeToken, onboardingWithInvitation }, formikBag) => {
            formikBag.props.dispatch(
                onboardingActions.captureSelfieMigration(
                    document,
                    gender,
                    exchangeToken,
                    onboardingWithInvitation === true,
                ),
            );
        },
    }),
)(StepCaptureSelfieMigration);
